/** @format */

export const sttGpsDevices = [
  {
    id: 1,
    deviceNumber: "STT-2026-0001",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-25",
    suppliedSubject: "Bo'ston fermer xo'jaligi",
    stir: "302145678",
    qrId: "QR-STT-0001",
    gpsId: "GPS-UZ-0001",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:45",
    region: "Qoraqalpog'iston",
    district: "To'rtko'l",
    location: "To'rtko'l tumani, Paxtakor MFY",
    lat: 41.552,
    lon: 60.998,
  },
  {
    id: 2,
    deviceNumber: "STT-2026-0002",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-27",
    suppliedSubject: "Qanliko'l Agro servis",
    stir: "302145679",
    qrId: "QR-STT-0002",
    gpsId: "GPS-UZ-0002",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-30 17:12",
    region: "Qoraqalpog'iston",
    district: "Qanliko'l",
    location: "Qanliko'l tumani, Jayhun hududi",
    lat: 42.842,
    lon: 59.004,
  },
  {
    id: 3,
    deviceNumber: "STT-2026-0003",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-28",
    suppliedSubject: "Sardoba tomorqa klasteri",
    stir: "305887410",
    qrId: "QR-STT-0003",
    gpsId: "GPS-UZ-0003",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:05",
    region: "Andijon",
    district: "Asaka",
    location: "Asaka tumani, Qoratepa massivi",
    lat: 40.641,
    lon: 72.238,
  },
  {
    id: 4,
    deviceNumber: "STT-2026-0004",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-25",
    suppliedSubject: "Bobur agro fermer xo'jaligi",
    stir: "305887411",
    qrId: "QR-STT-0004",
    gpsId: "GPS-UZ-0004",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 07:58",
    region: "Andijon",
    district: "Marhamat",
    location: "Marhamat tumani, Polvontosh hududi",
    lat: 40.479,
    lon: 72.313,
  },
  {
    id: 5,
    deviceNumber: "STT-2026-0005",
    type: "Nasos",
    manufacturer: "Smart Agro Pump",
    producedDate: "2026-09-27",
    suppliedSubject: "G'ijduvon Suvtejamkor MChJ",
    stir: "304551290",
    qrId: "QR-STT-0005",
    gpsId: "GPS-UZ-0005",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:17",
    region: "Buxoro",
    district: "G'ijduvon",
    location: "G'ijduvon tumani, Zarangari hududi",
    lat: 40.099,
    lon: 64.683,
  },
  {
    id: 6,
    deviceNumber: "STT-2026-0006",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-28",
    suppliedSubject: "Romitan dehqon xo'jaligi",
    stir: "304551291",
    qrId: "QR-STT-0006",
    gpsId: "GPS-UZ-0006",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-29 11:40",
    region: "Buxoro",
    district: "Romitan",
    location: "Romitan tumani, Gazli yo'nalishi",
    lat: 39.929,
    lon: 64.379,
  },
  {
    id: 7,
    deviceNumber: "STT-2026-0007",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-27",
    suppliedSubject: "Zomin Invest Agro",
    stir: "306770120",
    qrId: "QR-STT-0007",
    gpsId: "GPS-UZ-0007",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:32",
    region: "Jizzax",
    district: "Zomin",
    location: "Zomin tumani, Dashtobod massivi",
    lat: 39.96,
    lon: 68.395,
  },
  {
    id: 8,
    deviceNumber: "STT-2026-0008",
    type: "Filtr",
    manufacturer: "WaterControl Systems",
    producedDate: "2026-09-25",
    suppliedSubject: "Paxtakor irrigatsiya servis",
    stir: "306770121",
    qrId: "QR-STT-0008",
    gpsId: "GPS-UZ-0008",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 06:55",
    region: "Jizzax",
    district: "Paxtakor",
    location: "Paxtakor tumani, Oqbuloq hududi",
    lat: 40.315,
    lon: 67.954,
  },
  {
    id: 9,
    deviceNumber: "STT-2026-0009",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-25",
    suppliedSubject: "Kasbi Agro Tomchi",
    stir: "308441002",
    qrId: "QR-STT-0009",
    gpsId: "GPS-UZ-0009",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:11",
    region: "Qashqadaryo",
    district: "Kasbi",
    location: "Kasbi tumani, Maymanoq hududi",
    lat: 38.842,
    lon: 65.36,
  },
  {
    id: 10,
    deviceNumber: "STT-2026-0010",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-27",
    suppliedSubject: "Kitob bog'dorchilik klasteri",
    stir: "308441003",
    qrId: "QR-STT-0010",
    gpsId: "GPS-UZ-0010",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-29 19:26",
    region: "Qashqadaryo",
    district: "Kitob",
    location: "Kitob tumani, Varganza massivi",
    lat: 39.121,
    lon: 66.876,
  },
  {
    id: 11,
    deviceNumber: "STT-2026-0011",
    type: "Nasos",
    manufacturer: "Smart Agro Pump",
    producedDate: "2026-09-28",
    suppliedSubject: "Karmana tomchilatish servis",
    stir: "309220610",
    qrId: "QR-STT-0011",
    gpsId: "GPS-UZ-0011",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:02",
    region: "Navoiy",
    district: "Karmana",
    location: "Karmana tumani, Malik cho'li",
    lat: 40.137,
    lon: 65.36,
  },
  {
    id: 12,
    deviceNumber: "STT-2026-0012",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-28",
    suppliedSubject: "Qiziltepa Agro Kelajak",
    stir: "309220611",
    qrId: "QR-STT-0012",
    gpsId: "GPS-UZ-0012",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 07:35",
    region: "Navoiy",
    district: "Qiziltepa",
    location: "Qiziltepa tumani, Toshrobot hududi",
    lat: 40.03,
    lon: 64.849,
  },
  {
    id: 13,
    deviceNumber: "STT-2026-0013",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-27",
    suppliedSubject: "Pop Suv Tejamkor",
    stir: "301778340",
    qrId: "QR-STT-0013",
    gpsId: "GPS-UZ-0013",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-30 14:10",
    region: "Namangan",
    district: "Pop",
    location: "Pop tumani, Chodak yo'nalishi",
    lat: 40.873,
    lon: 71.108,
  },
  {
    id: 14,
    deviceNumber: "STT-2026-0014",
    type: "Filtr",
    manufacturer: "WaterControl Systems",
    producedDate: "2026-09-25",
    suppliedSubject: "Chortoq bog'bonlari",
    stir: "301778341",
    qrId: "QR-STT-0014",
    gpsId: "GPS-UZ-0014",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:22",
    region: "Namangan",
    district: "Chortoq",
    location: "Chortoq tumani, Baliqli ko'l hududi",
    lat: 41.067,
    lon: 71.823,
  },
  {
    id: 15,
    deviceNumber: "STT-2026-0015",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-28",
    suppliedSubject: "Bulung'ur Agro Suv",
    stir: "307991450",
    qrId: "QR-STT-0015",
    gpsId: "GPS-UZ-0015",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:51",
    region: "Samarqand",
    district: "Bulung'ur",
    location: "Bulung'ur tumani, Kildon massivi",
    lat: 39.767,
    lon: 67.271,
  },
  {
    id: 16,
    deviceNumber: "STT-2026-0016",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-28",
    suppliedSubject: "Kattaqo'rg'on tomchi servis",
    stir: "307991451",
    qrId: "QR-STT-0016",
    gpsId: "GPS-UZ-0016",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-10-01 09:47",
    region: "Samarqand",
    district: "Kattaqo'rg'on",
    location: "Kattaqo'rg'on tumani, Payshanba hududi",
    lat: 39.898,
    lon: 66.257,
  },
  {
    id: 17,
    deviceNumber: "STT-2026-0017",
    type: "Nasos",
    manufacturer: "Smart Agro Pump",
    producedDate: "2026-09-28",
    suppliedSubject: "Boysun Agrosuv MChJ",
    stir: "303664500",
    qrId: "QR-STT-0017",
    gpsId: "GPS-UZ-0017",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 07:19",
    region: "Surxondaryo",
    district: "Boysun",
    location: "Boysun tumani, Darband hududi",
    lat: 38.209,
    lon: 67.202,
  },
  {
    id: 18,
    deviceNumber: "STT-2026-0018",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-25",
    suppliedSubject: "Jarqo'rg'on suv tejash",
    stir: "303664501",
    qrId: "QR-STT-0018",
    gpsId: "GPS-UZ-0018",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:29",
    region: "Surxondaryo",
    district: "Jarqo'rg'on",
    location: "Jarqo'rg'on tumani, Minor hududi",
    lat: 37.505,
    lon: 67.42,
  },
  {
    id: 19,
    deviceNumber: "STT-2026-0019",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-27",
    suppliedSubject: "Guliston hosildor zamin",
    stir: "306118220",
    qrId: "QR-STT-0019",
    gpsId: "GPS-UZ-0019",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 06:48",
    region: "Sirdaryo",
    district: "Guliston",
    location: "Guliston tumani, Dehqonobod hududi",
    lat: 40.489,
    lon: 68.784,
  },
  {
    id: 20,
    deviceNumber: "STT-2026-0020",
    type: "Filtr",
    manufacturer: "WaterControl Systems",
    producedDate: "2026-09-28",
    suppliedSubject: "Oqoltin paxta klasteri",
    stir: "306118221",
    qrId: "QR-STT-0020",
    gpsId: "GPS-UZ-0020",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-29 16:15",
    region: "Sirdaryo",
    district: "Oqoltin",
    location: "Oqoltin tumani, Sardoba hududi",
    lat: 40.391,
    lon: 68.541,
  },
  {
    id: 21,
    deviceNumber: "STT-2026-0021",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-25",
    suppliedSubject: "Bo'ka Agro Invest",
    stir: "300991770",
    qrId: "QR-STT-0021",
    gpsId: "GPS-UZ-0021",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:58",
    region: "Toshkent",
    district: "Bo'ka",
    location: "Bo'ka tumani, Achamayli hududi",
    lat: 40.812,
    lon: 69.194,
  },
  {
    id: 22,
    deviceNumber: "STT-2026-0022",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-27",
    suppliedSubject: "Quyi Chirchiq tomorqa xizmati",
    stir: "300991771",
    qrId: "QR-STT-0022",
    gpsId: "GPS-UZ-0022",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:18",
    region: "Toshkent",
    district: "Quyi Chirchiq",
    location: "Quyi Chirchiq tumani, Do'stlik hududi",
    lat: 41.063,
    lon: 69.495,
  },
  {
    id: 23,
    deviceNumber: "STT-2026-0023",
    type: "Nasos",
    manufacturer: "Smart Agro Pump",
    producedDate: "2026-09-28",
    suppliedSubject: "Uchko'prik suv tejovchi texnika",
    stir: "301223560",
    qrId: "QR-STT-0023",
    gpsId: "GPS-UZ-0023",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-29 10:30",
    region: "Farg'ona",
    district: "Uchko'prik",
    location: "Uchko'prik tumani, Yangiobod hududi",
    lat: 40.54,
    lon: 71.066,
  },
  {
    id: 24,
    deviceNumber: "STT-2026-0024",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-27",
    suppliedSubject: "Quva tomchi agro",
    stir: "301223561",
    qrId: "QR-STT-0024",
    gpsId: "GPS-UZ-0024",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 07:44",
    region: "Farg'ona",
    district: "Quva",
    location: "Quva tumani, Akbarobod hududi",
    lat: 40.522,
    lon: 72.07,
  },
  {
    id: 25,
    deviceNumber: "STT-2026-0025",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-28",
    suppliedSubject: "Xonqa Agro Servis",
    stir: "302889130",
    qrId: "QR-STT-0025",
    gpsId: "GPS-UZ-0025",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:07",
    region: "Xorazm",
    district: "Xonqa",
    location: "Xonqa tumani, Qoraqosh hududi",
    lat: 41.468,
    lon: 60.763,
  },
  {
    id: 26,
    deviceNumber: "STT-2026-0026",
    type: "Filtr",
    manufacturer: "WaterControl Systems",
    producedDate: "2026-09-27",
    suppliedSubject: "Urganch meva-sabzavot klasteri",
    stir: "302889131",
    qrId: "QR-STT-0026",
    gpsId: "GPS-UZ-0026",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-10-01 12:51",
    region: "Xorazm",
    district: "Urganch",
    location: "Urganch tumani, Chakkasholikor hududi",
    lat: 41.565,
    lon: 60.641,
  },
  {
    id: 27,
    deviceNumber: "STT-2026-0027",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-28",
    suppliedSubject: "Mingbuloq Agro Smart",
    stir: "301778342",
    qrId: "QR-STT-0027",
    gpsId: "GPS-UZ-0027",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:31",
    region: "Namangan",
    district: "Mingbuloq",
    location: "Mingbuloq tumani, Momoxon hududi",
    lat: 40.905,
    lon: 71.388,
  },
  {
    id: 28,
    deviceNumber: "STT-2026-0028",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-28",
    suppliedSubject: "Mirzaobod fermer servis",
    stir: "306118222",
    qrId: "QR-STT-0028",
    gpsId: "GPS-UZ-0028",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:40",
    region: "Sirdaryo",
    district: "Mirzaobod",
    location: "Mirzaobod tumani, Navro'z hududi",
    lat: 40.515,
    lon: 68.627,
  },
  {
    id: 29,
    deviceNumber: "STT-2026-0029",
    type: "Nasos",
    manufacturer: "Smart Agro Pump",
    producedDate: "2026-09-25",
    suppliedSubject: "Denov bog'dorchilik klasteri",
    stir: "303664502",
    qrId: "QR-STT-0029",
    gpsId: "GPS-UZ-0029",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-27 08:04",
    region: "Surxondaryo",
    district: "Denov",
    location: "Denov tumani, Qizilsuv hududi",
    lat: 38.267,
    lon: 67.898,
  },
  {
    id: 30,
    deviceNumber: "STT-2026-0030",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-27",
    suppliedSubject: "Pastdarg'om tomorqa markazi",
    stir: "307991452",
    qrId: "QR-STT-0030",
    gpsId: "GPS-UZ-0030",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 06:38",
    region: "Samarqand",
    district: "Pastdarg'om",
    location: "Pastdarg'om tumani, Juma hududi",
    lat: 39.653,
    lon: 66.86,
  },
  {
    id: 31,
    deviceNumber: "STT-2026-0031",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-28",
    suppliedSubject: "Chust suv tejash servis",
    stir: "301778343",
    qrId: "QR-STT-0031",
    gpsId: "GPS-UZ-0031",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:44",
    region: "Namangan",
    district: "Chust",
    location: "Chust tumani, Olmos hududi",
    lat: 41.003,
    lon: 71.237,
  },
  {
    id: 32,
    deviceNumber: "STT-2026-0032",
    type: "Filtr",
    manufacturer: "WaterControl Systems",
    producedDate: "2026-09-25",
    suppliedSubject: "Parkent Agro MChJ",
    stir: "300991772",
    qrId: "QR-STT-0032",
    gpsId: "GPS-UZ-0032",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-28 18:22",
    region: "Toshkent",
    district: "Parkent",
    location: "Parkent tumani, So'qoq hududi",
    lat: 41.294,
    lon: 69.676,
  },
  {
    id: 33,
    deviceNumber: "STT-2026-0033",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-27",
    suppliedSubject: "Qo'shtepa fermer kooperativi",
    stir: "301223562",
    qrId: "QR-STT-0033",
    gpsId: "GPS-UZ-0033",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:23",
    region: "Farg'ona",
    district: "Qo'shtepa",
    location: "Qo'shtepa tumani, Qumtepa hududi",
    lat: 40.52,
    lon: 71.63,
  },
  {
    id: 34,
    deviceNumber: "STT-2026-0034",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-28",
    suppliedSubject: "Olot Agro Texnika",
    stir: "304551292",
    qrId: "QR-STT-0034",
    gpsId: "GPS-UZ-0034",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 07:02",
    region: "Buxoro",
    district: "Olot",
    location: "Olot tumani, Qorako'l yo'nalishi",
    lat: 39.417,
    lon: 63.801,
  },
  {
    id: 35,
    deviceNumber: "STT-2026-0035",
    type: "Nasos",
    manufacturer: "Smart Agro Pump",
    producedDate: "2026-09-28",
    suppliedSubject: "Mirishkor Agro Suv",
    stir: "308441004",
    qrId: "QR-STT-0035",
    gpsId: "GPS-UZ-0035",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-30 20:18",
    region: "Qashqadaryo",
    district: "Mirishkor",
    location: "Mirishkor tumani, Pomuq hududi",
    lat: 38.851,
    lon: 64.846,
  },
  {
    id: 36,
    deviceNumber: "STT-2026-0036",
    type: "Filtr",
    manufacturer: "Hydro Filter Group",
    producedDate: "2026-09-27",
    suppliedSubject: "Yangibozor tomchi xizmati",
    stir: "302889132",
    qrId: "QR-STT-0036",
    gpsId: "GPS-UZ-0036",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:03",
    region: "Xorazm",
    district: "Yangibozor",
    location: "Yangibozor tumani, Gullanbog' hududi",
    lat: 41.71,
    lon: 60.468,
  },
  {
    id: 37,
    deviceNumber: "STT-2026-0037",
    type: "Nasos",
    manufacturer: "AgroPump Tech",
    producedDate: "2026-09-28",
    suppliedSubject: "Nurobod Agro Service",
    stir: "307991453",
    qrId: "QR-STT-0037",
    gpsId: "GPS-UZ-0037",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 08:16",
    region: "Samarqand",
    district: "Nurobod",
    location: "Nurobod tumani, Jom hududi",
    lat: 39.608,
    lon: 66.94,
  },
  {
    id: 38,
    deviceNumber: "STT-2026-0038",
    type: "Filtr",
    manufacturer: "WaterControl Systems",
    producedDate: "2026-09-27",
    suppliedSubject: "Shofirkon Suvtejamkor",
    stir: "304551293",
    qrId: "QR-STT-0038",
    gpsId: "GPS-UZ-0038",
    gpsStatus: "Nofaol",
    lastSignalAt: "2026-09-29 13:11",
    region: "Buxoro",
    district: "Shofirkon",
    location: "Shofirkon tumani, Jo'yrabot hududi",
    lat: 40.126,
    lon: 64.501,
  },
  {
    id: 39,
    deviceNumber: "STT-2026-0039",
    type: "Nasos",
    manufacturer: "UzIrrigation Machinery",
    producedDate: "2026-09-25",
    suppliedSubject: "Xatirchi intensiv bog'",
    stir: "309220612",
    qrId: "QR-STT-0039",
    gpsId: "GPS-UZ-0039",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 07:53",
    region: "Navoiy",
    district: "Xatirchi",
    location: "Xatirchi tumani, Langar hududi",
    lat: 40.12,
    lon: 65.958,
  },
  {
    id: 40,
    deviceNumber: "STT-2026-0040",
    type: "Filtr",
    manufacturer: "AquaLine Engineering",
    producedDate: "2026-09-25",
    suppliedSubject: "Oltiariq suv tejash markazi",
    stir: "301223563",
    qrId: "QR-STT-0040",
    gpsId: "GPS-UZ-0040",
    gpsStatus: "Faol",
    lastSignalAt: "2026-10-02 09:27",
    region: "Farg'ona",
    district: "Oltiariq",
    location: "Oltiariq tumani, Eskiarab hududi",
    lat: 40.392,
    lon: 71.475,
  },
];